<div class="position-relative">
  <div class="d-flex align-items-center gap-3" style="gap: 1rem;" (click)="focusOnInput();">
    <ng-container *ngFor="let _ of otpArr; index as i">
      <!--    <input-->
      <!--      #otpInput-->
      <!--      type="text"-->
      <!--      class="form-control text-center text-uppercase"-->
      <!--      maxlength="1"-->
      <!--      [(ngModel)]="otpArr[i]"-->
      <!--      (ngModelChange)="onValueChangeEvent($event)"-->
      <!--      [name]="'otp-' + i"-->
      <!--      (input)="moveFocus($event, i)"-->
      <!--      (focus)="onFocus($event)"-->
      <!--      (keydown.backspace)="onKeyDown($event, i)"-->
      <!--      (paste)="onPaste($event)"-->
      <!--      inputmode="numeric"-->
      <!--    />-->
      <div class="form-control text-center text-uppercase"
        [style]="(isFocused && (otp.length >= (i))) ? 'border-color:#31ce77!important' : 'border-color:#dee2e6!important'"
      >{{otp[i]}}</div>
    </ng-container>
  </div>

  <div class="input-wrapper">
    <input
      #otpInput type="text"
      [(ngModel)]="otp"
      (ngModelChange)="onValueChangeEvent($event)"
      [maxlength]="otpLength"
      [name]="'otp-input'"
      inputmode="numeric"
      (paste)="onPaste($event)"
      (focus)="isFocused = true;"
      (blur)="isFocused = false;"
    />
  </div>
</div>
